module.exports = __webpack_public_path__ + "img/logo-alltricks.398d9091.svg";